import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

import CertificationSupplierEditModal from '../../CertificationSuppliers/Elements/CertificationSupplierEditModal';
import getLocale from '../../../i18n/getLocale';

class SupplierCertificationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      data_certification_supplier: null,
      supplier_certifications: [],
      country_list: [],
      certifications_list: [],
      id: this.props.supplier_id,
      certification_id: '',
      modal_props: false,
    };

    this.locale = getLocale();

    //bind específico
    this.addCertification = this.addCertification.bind(this);
    this.deleteCertification = this.deleteCertification.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.supplier_id !== 'undefined' && Array.isArray(newProps.country_list) && Array.isArray(newProps.certifications_list) && Array.isArray(newProps.supplier_certifications) && this.state.loaded === false) {
      this.setState({
        id: newProps.supplier_id,
        country_list: newProps.country_list,
        certifications_list: newProps.certifications_list,
        supplier_certifications: newProps.supplier_certifications,
        loaded: true,
      });
    }
  }
  
  // Fetch salvando a edição
  addCertification(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      certification_id: this.state.certification_id,
      supplier_id: this.state.id,
      anac_code: this.state.anac_code,
      expiration: this.state.expiration,
      certification: this.state.certification,
      returning_deadline: this.state.returning_deadline,
      hour_value: this.state.hour_value,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      contact_name: this.state.contact_name,
      country_id: this.state.country_id,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
      save_type: 'SupplierToCertification',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fornecedor/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.supplier_certifications;
          dados_temp.push(responseJson.data);
          self.setState({supplier_certifications: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  deleteCertification (event) {
    var certification_supplier_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.deletarCertificado);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/certificado/' + certification_supplier_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(certification_supplier_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  deleteRow(certification_supplier_id) {
    var supplier_certifications = this.state.supplier_certifications;
    supplier_certifications.map(function(dado, index){
      if (dado.id == certification_supplier_id) {
        supplier_certifications.splice(index, 1);
      }
    });
    this.setState({supplier_certifications: supplier_certifications});
  }

  loadData (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/certificado/fornecedor/editar/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_certification_supplier:responseJson.data});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/fornecedor/certificados/'+self.props.supplier_id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({supplier_certifications: responseJson.data});
          self.props.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }



  // Fetch ativando um item
  activate(id) {
    var confirm = window.confirm(this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.ativarFornecedor);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/certificado/ativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({supplier_certifications: responseJson.data});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  archive(id) {
    var confirm = window.confirm(this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.arquivarFornecedor);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/certificado/desativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({supplier_certifications: responseJson.data});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div>
    {(this.state.supplier_certifications === null || typeof this.state.supplier_certifications === 'undefined') ?  '' 
    : 
      <table className="table">
        <thead>
          <tr>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Certificado}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Tipo}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Telefone}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Cidade}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Pais}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Expiracao}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.CustoH}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Reembolso}
            </th>
            <th>
              {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Status}
            </th>
            <th>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tabela.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.supplier_certifications).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.supplier_certifications[k].certification_name}
                </td>
                <td>
                  {self.state.supplier_certifications[k].type}
                </td>
                <td>
                  {self.state.supplier_certifications[k].phone}
                </td>
                <td>
                  {self.state.supplier_certifications[k].city}
                </td>
                <td>
                  {self.state.supplier_certifications[k].country}
                </td>
                <td>
                  {self.state.supplier_certifications[k].expiration_str}
                </td>
                <td>
                  {self.state.supplier_certifications[k].hour_value}
                </td>
                <td>
                  {self.state.supplier_certifications[k].returning_deadline}
                </td>
                <td className="text-center">
                  {(self.state.supplier_certifications[k].active === 1) ?  <span className="label label-success">{self.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.Ativo}</span> : <span className="label label-danger">{self.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.Arquivado}</span>}
                </td>
                <td>
                  <div className="btn-group">
                  {(self.state.supplier_certifications[k].active === 1) ?  
                    <button className="btn btn-sm btn-danger" value={self.state.supplier_certifications[k].id} onClick={()=>self.archive(self.state.supplier_certifications[k].id)}><i className="fa fa-fw fa-power-off"></i></button>
                    :
                    <button className="btn btn-sm btn-success" value={self.state.supplier_certifications[k].id} onClick={()=>self.activate(self.state.supplier_certifications[k].id)}><i className="fa fa-fw fa-power-off"></i></button>
                  }
                    <button onClick={self.loadData.bind(self, self.state.supplier_certifications[k])} className='btn btn-sm btn-primary' alt={self.locale.general.editar} title={self.locale.general.editar}><i className="fa fa-fw fa-pencil"></i></button>
                    <button className="btn btn-sm btn-danger" value={self.state.supplier_certifications[k].id} onClick={self.deleteCertification}>
                      <i className="fa fa-fw fa-trash"></i>
                    </button>
                  </div>  
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    }
  </div>
  <hr/>
  <div>
    <h4>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.tituloAdicionarCertificado}</h4>
    <form onSubmit={this.addCertification}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Certificados}:</label>
            <Select
              className="form-field-name"
              name="certification_id"
              value={this.state.certification_id}
              searchable={true}
              placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.SelecionarCertificado}
              onChange={this.handleSelectChange.bind(this, 'certification_id')}
              options={this.state.certifications_list}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.CodigoANAC}:</label>
            <input type="text" name="anac_code" className="form-control" placeholder="" value={this.state.anac_code} onChange={this.handleChange.bind(this, 'anac_code')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Expiracao}:</label>
            <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Certificacao}:</label>
            <input type="text" name="certification" className="form-control" placeholder="" value={this.state.certification} onChange={this.handleChange.bind(this, 'certification')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.PrazoParaCancelamentoComRetornoDoPagamentoEmDias}:</label>
            <InputMask value={this.state.returning_deadline}  maskChar={null} name="returning_deadline" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'returning_deadline')} placeholder="" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Endereco}:</label>
            <input type="text" name="address" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.EnderecoDoFornecedor} value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Cidade}:</label>
            <input type="text" name="city" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.CidadeDofornecedor} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Estado}:</label>
            <input type="text" name="province" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.EstadoProvinciaDoFornecedor} value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Pais}:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.SelecionarPais}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.country_list}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.ContatoNome}:</label>
            <input type="text" name="contact_name" className="form-control" placeholder="" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Telefone}:</label>
            <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.TelefoneDoFornecedor} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Email}:</label>
            <input type="text" name="email" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.placeholder.EmailDoFornecedor} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.Observacoes}:</label>
            <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.ValorHora}:</label>
            <InputMask value={this.state.hour_value}  maskChar={null} name="hour_value" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Fornecedores.EditarFornecedor.tabCertificadosDoFornecedor.formulario.botaoSalvarCertificado}</button>
        </div>
      </div>
    </form>
  </div>
  <CertificationSupplierEditModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} data_certification_supplier={self.state.data_certification_supplier} refreshTable={self.refreshTable} country_list={self.state.country_list} />
</div>
    );
  }
}

export default SupplierCertificationsTab;



// WEBPACK FOOTER //
// ./src/Components/Suppliers/Elements/SupplierCertificationsTab.js